import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    signer,
    timeSign,
    firstTime,
    supplementaryForThe,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    taxAgentName,
    taxAgentId,
    taxCalculationPeriodEnd,
    hightIncomeBusiness,
    percent,
    contract,
    contractDate,
  },
} = checkout;

const initialValues = {
  [taxAgentName.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [taxAgentId.name]: "",
  [taxCalculationPeriodEnd.name]: "",
  [hightIncomeBusiness.name]: "",
  [percent.name]: "",
  [contract.name]: "",
  [contractDate.name]: "",
};

export default initialValues;
